// extracted by mini-css-extract-plugin
module.exports = {"icon-bullets":"_2_gpL","iconBullets":"_2_gpL"};